import {invalidateWorkspaceMemory} from '../workspaceMemory';
export function stripeDestination(value,operation){
 const url=new URL(value);
 const host=operation==='checkout'?'checkout.stripe.com':'billing.stripe.com';
 if(url.protocol!=='https:'||url.hostname!==host||url.username||url.password||url.port)throw new Error('invalid_destination');
 return url.href;
}
export function checkoutRequest(scope,version){
 const key='cybe-sandbox-checkout:'+scope;
 let old;try{old=JSON.parse(sessionStorage.getItem(key));}catch{}
 if(old?.version!==version||typeof old?.request_id!=='string')old={version,request_id:crypto.randomUUID()};
 sessionStorage.setItem(key,JSON.stringify(old));
 return {request_id:old.request_id,expected_draft_version:version};
}
export function forgetCheckout(scope){sessionStorage.removeItem('cybe-sandbox-checkout:'+scope);}
export async function paymentRequest(url,token,body,signal){
 const controller=new AbortController(),abort=()=>controller.abort();
 signal?.addEventListener('abort',abort,{once:true});if(signal?.aborted)controller.abort();
 const timer=setTimeout(abort,30000);
 try{
  const response=await fetch(url,{method:'POST',cache:'no-store',signal:controller.signal,headers:{Authorization:'Bearer '+token,'Content-Type':'application/json'},body:JSON.stringify(body)});
  const data=await response.json();
  if(!response.ok){const e=new Error(data.error||'billing_unavailable');e.status=response.status;throw e;}
  invalidateWorkspaceMemory();return data;
 }finally{clearTimeout(timer);signal?.removeEventListener('abort',abort);}
}

export function planChangeRequest(scope,version,selection){
 const key='cybe-sandbox-plan-change:'+scope,signature=JSON.stringify([version,selection]);
 let old;try{old=JSON.parse(sessionStorage.getItem(key));}catch{}
 if(old?.signature!==signature||typeof old?.request_id!=='string')old={signature,request_id:crypto.randomUUID()};
 sessionStorage.setItem(key,JSON.stringify(old));
 return {request_id:old.request_id,expected_subscription:version,...selection};
}
export function forgetPlanChange(scope){sessionStorage.removeItem('cybe-sandbox-plan-change:'+scope);}

export async function planReviewRequest(url,token,body,signal,scope){
 try{return await paymentRequest(url,token,body,signal);}
 catch(error){
  if(error.status!==410||error.message!=='change_review_expired'||body.cancel_scheduled_change||signal?.aborted)throw error;
  forgetPlanChange(scope);
  const fresh=planChangeRequest(scope,body.expected_subscription,{plan_slug:body.plan_slug,billing_interval:body.billing_interval});
  return paymentRequest(url,token,fresh,signal);
 }
}
